import VueCookies from "vue-cookies";

export function useUserInfo() {
  const userInfo = VueCookies.get("userInfo");
  return {
    ...userInfo,
  };
}
